import React, { Fragment } from 'react';
import { string, oneOfType, arrayOf, element } from 'prop-types';
import styled from 'styled-components';
import { Icon, Image, Header } from 'semantic-ui-react';


const StyledHeader = styled(Header)`
    && {
        margin-bottom: 2rem;
    }
`;

const Actions = styled.div`
    display: flex;
    margin-bottom: 3rem;

    .ui.button:first-child {
        margin-left: 0;
    }
`;


const Heading = ({
    imageSrc,
    iconName,
    header,
    subheader,
    children,
}) => (
    <Fragment>
        <StyledHeader as="h1">
            { imageSrc &&
                <Image src={imageSrc} rounded />
            }
            { iconName &&
                <Icon name={iconName} />
            }
            <Header.Content>
                { header }
                <Header.Subheader>
                    { subheader }
                </Header.Subheader>
            </Header.Content>
        </StyledHeader>

        { children &&
            <Actions>{ children }</Actions>
        }
    </Fragment>
);

Heading.propTypes = {
    imageSrc: string,
    iconName: string,
    header: string.isRequired,
    subheader: string,
    children: oneOfType([element, arrayOf(element)]),
};

export default Heading;
